import UserApi from '../../api/src/user/api/UserApi'
const userApi = new UserApi();
const state = {
    currentUser: {
        id: undefined,
        name: null,
        xiaoquId: null,
        xiaoqu: null,
        loudongId: null,
        loudong: null,
        roomId: null,
        room: null,
        usedAmp: null,
        allAmp: null
    }
  };

const  mutations =  {
    overLogin (state, payload) {
      state.currentUser = payload
    },
    overSaveRoom (state, payload) {
      state.currentUser = payload
    }
  }

const actions = {
  async login ({ commit }, { data }) {
    console.log(data)
    let resp = await userApi.login(data);
    commit('overLogin', resp)
    return resp;
  },
  async saveRoom ({ commit }, {data}) {
    let resp = await userApi.update(data);
    commit('overSaveRoom', resp)
    return resp
  }
}

  export default {
    namespaced: true,
    state,
    actions,
    mutations
  }